<div class="container mt-4" *ngIf="!isDonation && !isPaymentHistory">
  <h1 class="d-flex align-items-start">Donation History</h1>
  <div class="chk-block-content mt-2">
    <div class="d-flex justify-content-end align-items-center mb-2">
      <button class="btn btn-primary" (click)="AddNew(content);" title="Add New Doner">
        Add New Doner</button>
      <!---- Add New Patient/Guest (click)="AddNew(content);GetsigninDetails('Addbutton')" ------>
    </div>
    <div class="table-responsive">
      <div class="unseen">
        <table class="table table-striped table-hover  text-left " data-page-size="15" data-filtering="true"
          data-sorting="true">
          <thead>
            <tr class="bg-white"> <!-- class="bg-white" -->
              <th style="min-width: 30px !important; max-width: 30px !important;">No.</th>
              <th>Guest Name</th>
              <th>DOB</th>
              <th>Age</th>
              <th>Gender</th>
              <th>Address</th>
              <th class="numeric text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let item of items | filter : filters | paginate: { itemsPerPage: 10, currentPage: page };  let i = index">
              <td style="min-width: 20px !important; max-width: 20px !important;">
                {{ 10 * (page - 1) + i + 1}}
              </td>
              <td>{{item.GuestName}}</td>
              <td>{{item.DateOfBirth | date:"dd-MMM-yyyy"}}</td>
              <td>{{item.Age}}</td>
              <td> {{item.Gender}}</td>
              <td> {{item.Address}}</td>
              <td
                class="numeric text-center font-sm text-nowrap style=min-width: 30px !important; max-width: 30px !important;">
                <i class="fa-lg fas fa-hand-holding-heart mr-1" style="color:#28a745"
                  (click)="Makedonation(item.OnlinePatientRegistrationID)" title="Make donation"></i>
                <i class="fa fa-money mr-1 text-warning" (click)="GetPaymentHistory(item.OnlinePatientRegistrationID);"
                  title="Payment history"></i>
              </td>
          </tbody>
        </table>
      </div>
      <pagination-controls (pageChange)="page = $event" [maxSize]="10" [directionLinks]="true" [autoHide]="true"
        [responsive]="true">
      </pagination-controls> <!----- Page No ------>
    </div>
  </div>
</div>

<div class="container mt-4" *ngIf="isDonation && !isPaymentHistory">
  <h1 class="d-flex align-items-start">Make a Donation</h1>
  <div class="chk-block-content mt-4">
    <div class="row mt-3">
      <div class="col-lg">
        <div class="grid-b-space">
          <div class="row">
            <div class="col-md-3 text-left mt-2">
              <strong id="lblDonorName">Donor Name</strong><!--Donor Name-->
            </div>
            <div class="col-md-5 text-left mt-2">
              <strong>{{GuestName}}</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 text-left mt-2">
              <strong id="lblPaymentDateandTime">Payment Date and Time</strong>
            </div>
            <div class="col-md-5 text-left mt-2">
              <strong>{{Today}}</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 text-left mt-2">
              <strong id="lblEmail">E-mail</strong><!--E-mail-->
            </div>
            <div class="col-md-5 text-left mt-2">
              <strong>{{UserEmail}}</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 text-left mt-2">
              <strong id="lblAccomodation">Phone number</strong>
            </div>
            <div class="col-md-5 text-left mt-2">
              <strong>{{MobileNo}}</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 text-left mt-2">
              <strong id="lblStatus">Donation Amount (Rs.)</strong>
            </div>
            <div class="col-md-5 mt-2">
              <input type="text" class="form-control" name="DAmount" autocomplete="off" id="DAmount"
                [(ngModel)]="DonationAmount" (keypress)="validateService.numberOnly($event)" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 text-left mt-2">
              <strong id="lblPayment">Payment Service Provider</strong>
            </div>
            <div class="col-md-5 mt-2">
              <input type="text" class="form-control" name="PaymentServiceProvider" autocomplete="off"
                id="PaymentServiceProvider" placeholder="Razorpay Payment Gateway" disabled />
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-2">
          <button class="btn btn-danger fa-sm ml-5 mt-1" (click)="CancelDonationPayment()">Cancel Payment</button>
          <button class="btn btn-success fa-sm mr-5 mt-1" [disabled]="DonationAmount == 0" (click)="GetRazorpay()">Make
            Donation Payment</button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-caa="close('a')">
  <div class="bg-white px-4 py-4 shadow-box rounded">
    <form name="EditClient" class="container-fluid" #f="ngForm" novalidate>
      <div class="">
        <div class="container mt-3">
          <div class="row mt-4 text-center">
            <h1 style="font-family: sans-serif;font-size: 2em;">
              {{+itemToEdit.OnlinePatientRegistrationID == 0 ? 'Add Guest details' : 'Edit Guest details'}}</h1>
          </div>
          <div class="row grid-b ">
            <div class="col-lg-3"> <!-----  Prefix ------>
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id="lblPrefix">Prefix </strong>
                <select class="form-select form-control" name="Prefix" id="Prefix" title="Select Prefix"
                  [(ngModel)]="itemToEdit.Prefix">
                  <option disabled value="">Select Prefix</option>
                  <option *ngFor="let prefix of Prefix" [value]="prefix.Description">{{ prefix.Description }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-3"> <!-----  First Name ------>
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id="lblFirstName">First Name <span style="color: red;">*</span></strong>
                <input type="text" name="FirstName" id="FirstName" class="form-control"
                  (input)="UpperCase(itemToEdit.FirstName,'FirstName');TrimName(itemToEdit.FirstName,'FirstName');"
                  [(ngModel)]="itemToEdit.FirstName" autocomplete="off" />
              </div>
            </div>
            <div class="col-lg-3"> <!-----  Middle Name ------>
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id="lblMiddleName">Middle Name </strong>
                <input type="text" name="MiddleName" id="MiddleName" class="form-control"
                  (input)="UpperCase(itemToEdit.MiddleName,'MiddleName');TrimName(itemToEdit.MiddleName,'MiddleName');"
                  [(ngModel)]="itemToEdit.MiddleName" autocomplete="off" />
              </div>
            </div>
            <div class="col-lg-3"> <!-----  Last Name ------>
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id="lblLastName">Last Name <span style="color: red;">*</span></strong>
                <input type="text" name="LastName" id="LastName" class="form-control"
                  (input)="UpperCase(itemToEdit.LastName,'LastName');TrimName(itemToEdit.LastName,'LastName');"
                  [(ngModel)]="itemToEdit.LastName" autocomplete="off" />
              </div>
            </div>
          </div>
          <div class="row grid-b">
            <div class="col-lg-3">
              <div class="form-group text-left fontsizeandfamilyCalibri"> <!--Date Of Birth-->
                <strong id="DateOfBirth">Date Of Birth <span style="color: red;">*</span></strong>
                <div class="input-group">
                  <input class="form-control" matInput name="DateOfBirth" [matDatepicker]="DateOfBirth" [max]="Today"
                    [(ngModel)]="itemToEdit.DateOfBirth" disabled
                    (dateChange)="calculateAge(itemToEdit.DateOfBirth, Today)" />
                  <span class="input-group-append">
                    <mat-datepicker-toggle matSuffix [for]="DateOfBirth"></mat-datepicker-toggle>
                    <mat-datepicker #DateOfBirth disabled="false"></mat-datepicker>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="form-group text-left fontsizeandfamilyCalibri"> <!----- Age ------>
                <strong id="lblAge">Age </strong>
                <input type="text" name="Age" id="Age" class="form-control" [(ngModel)]="itemToEdit.Age" disabled
                  placeholder="Age">
              </div>
            </div>
            <div class="col-lg-3"> <!----- Gender ------>
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id="lblGender">Gender <span style="color: red;">*</span></strong>
                <select class="form-select form-control" name="Gender" id="Gender" title="Select Gender"
                  [(ngModel)]="itemToEdit.Gender">
                  <option disabled value="">Select Gender</option>
                  <option *ngFor="let gender of genders" [value]="gender.value">{{ gender.description }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-3"> <!----- RelationWithUser ------>
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id="lblRelationWithUser">Relation With User</strong>
                <input type="text" name="RelationWithUser" id="RelationWithUser" class="form-control"
                  [(ngModel)]="itemToEdit.RelationWithUser">
              </div>
            </div>
            <div class="col-lg-3">
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id='lblGSM1'> Mobile Number </strong>
                <div class="input-group">
                  <input type="text" name="RegGSM" id="RegGSM" class="form-control" [(ngModel)]="itemToEdit.GSM"
                    maxlength="10" (keypress)='validateService.numberOnly($event)' required>
                  <div class="input-group-append"> <!--Whatsapp connected-->
                    <span class="input-group-text password-toggle" (click)="GetGSMasWAGSM(isUserWAGSM, 'Guest');">
                      <i class='fa fa-whatsapp' style="color: green;" title="WhatsApp Connected?"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 fontsizeandfamilyCalibri">
              <div class="form-group text-left">
                <strong id='lblWAGSM'>WhatsApp Mobile Number</strong>
                <!-- (click)="GetSelectedRowOpIpID(item.OpIpID,$event.target.checked);" -->
                <input type="text" name="WAGSM" id="WAGSM" class="form-control"
                  (keypress)='validateService.numberOnly($event)' maxlength="10" [(ngModel)]="itemToEdit.WAGSM"
                  required>
              </div>
            </div>
            <div class="col-lg-3 fontsizeandfamilyCalibri"> <!----- Preferred Language ------>
              <div class="form-group text-left">
                <strong id='lblPreferredLanguage'>Preferred Language</strong>
                <select class="form-select form-control" name="PreferredLanguage" id="PreferredLanguage"
                  title="Select Preferred Language" [(ngModel)]="itemToEdit.PreferredLanguage">
                  <option disabled value="">Select Preferred Language</option>
                  <option *ngFor="let lang of LanguageType" [value]="lang.Description">{{ lang.Description }}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-3 fontsizeandfamilyCalibri">
              <div class="form-group text-left">
                <strong id='lblUserEmail'>{{IsUserEmailSend ? 'OTP' : 'Email'}} <span style="color: red;">*</span>
                </strong>
                <div class="input-group" *ngIf="!IsUserEmailSend">
                  <input type="text" class="form-control" placeholder="Email Address" id="email" name="email"
                    [(ngModel)]="itemToEdit.GuestEmail" (keypress)='validateService.validateEmail($event)' required
                    email>
                  <!-- <div class="input-group-appent">
                    <button type="button" id="SendGuestOTP" class="btn btn-md btnpadding bg-primary ml-2"
                      [disabled]="itemToEdit.GuestEmail == ''" *ngIf="!IsEmailVerified"
                      (click)="VerifyUserEmail('GuestVerify');">
                      Send OTP</button>
                    <div *ngIf="IsEmailVerified" class="text-success font-weight-bold">
                      <i class="fas fa-check-circle"></i>
                    </div>
                  </div> -->
                </div>
                <div class="input-group" *ngIf="IsUserEmailSend">
                  <input type="text" class="form-control" placeholder="OTP" id="GuestOTP" name="GuestOTP"
                    [(ngModel)]="GuestOTP" (keypress)='validateService.numberOnly($event)' required email>
                  <div class="input-group-appent">
                    <button type="button" id="VerifyGuestOTP" class="btn btn-md btnpadding bg-primary ml-2"
                      [disabled]="GuestOTP.length < 4"
                      (click)="VerifyOTP(itemToEdit.GuestEmail,GuestOTP, 'GuestVerify');">
                      Verify OTP</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row grid-b">
            <div class="col-lg-3 fontsizeandfamilyCalibri">
              <div class="form-group text-left"> <!----- Address ------>
                <strong id="lblAddress">Address <span style="color: red;">*</span></strong>
                <textarea type="text" name="Address" id="Address" class="form-control" [(ngModel)]="itemToEdit.Address"
                  placeholder="Address"></textarea>
              </div>
            </div>
            <div class="col-lg-3 fontsizeandfamilyCalibri">
              <div class="form-group text-left"> <!----- Country ------>
                <strong id="lblAddress">Country <span style="color: red;">*</span></strong>
                <input type="text" name="Country" id="Country" class="form-control" [matAutocomplete]="auto"
                  [(ngModel)]="itemToEdit.Country" placeholder="Country">
              </div>
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let City of CountryandNationality | filter: itemToEdit.Country"
                  [value]="City['Country']" title="{{ City['Country'] }}">
                  {{City['Country']}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3 fontsizeandfamilyCalibri">
              <div class="form-group text-left"> <!----- State ------>
                <strong id="lblState">State</strong>
                <input type="text" name="State" id="State" class="form-control" [matAutocomplete]="autoState"
                  [(ngModel)]="itemToEdit.State" placeholder="State">
              </div>
              <mat-autocomplete #autoState="matAutocomplete">
                <mat-option *ngFor="let state of States | filter: itemToEdit.State;trackBy: trackByFn;"
                  (onSelectionChange)="GetDistrictList($event);" [value]="state['State']" title="{{ state['State'] }}">
                  {{state['State']}}
                </mat-option>
              </mat-autocomplete>
            </div>

            <div class="col-lg-3 fontsizeandfamilyCalibri">
              <div class="form-group text-left"> <!----- District  [disabled]="itemToEdit.BookingID !=0" ------>
                <strong id="lblDistrict">District</strong>
                <input type="text" name="District" id="District" class="form-control" [matAutocomplete]="autoDistrict1"
                  [(ngModel)]="itemToEdit.District" placeholder="District">
              </div>
              <mat-autocomplete #autoDistrict1="matAutocomplete">
                <mat-option *ngFor="let cc of District| filter: itemToEdit.District;trackBy: trackByFn;"
                  (onSelectionChange)="GetDistrictList($event);GetCityList($event,'Guest');" [value]="cc['District']"
                  title="{{ cc['District'] }}">
                  {{cc['District']}}
                </mat-option>
              </mat-autocomplete>
            </div>
          </div>
          <div class="row grid-b">
            <div class="col-lg-3 fontsizeandfamilyCalibri">
              <div class="form-group text-left"> <!----- City ------>
                <strong id="lblCity">City</strong>
                <input type="text" name="City" id="City" class="form-control" [matAutocomplete]="autoCity"
                  [(ngModel)]="itemToEdit.City" placeholder="City">
              </div>
              <mat-autocomplete #autoCity="matAutocomplete">
                <mat-option *ngFor="let aa of City | filter: itemToEdit.City;trackBy: trackByFn;" [value]="aa['City']"
                  title="{{ aa['City'] }}">
                  {{aa['City']}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3">
              <div class="form-group text-left fontsizeandfamilyCalibri"> <!----- Nationality ------>
                <strong id="lblNationality">Nationality <span style="color: red;">*</span></strong>
                <input type="text" name="Nationality" id="Nationality" class="form-control"
                  [matAutocomplete]="autoNationality" [(ngModel)]="itemToEdit.Nationality" placeholder="Nationality">
              </div>
              <mat-autocomplete #autoNationality="matAutocomplete" (optionSelected)="SetMandatoryAadharandPassport();">
                <mat-option *ngFor="let Nation of CountryandNationality | filter: itemToEdit.Nationality"
                  [value]="Nation['Nationality']" title="{{ Nation['Nationality'] }}">
                  {{Nation['Nationality']}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-3"> <!----- Aadhar No ------>
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id="lblAadharNo">Aadhar No.</strong>
                <input type="text" name="AadharNo" id="AadharNo" class="form-control" [(ngModel)]="itemToEdit.AadharNo"
                  (keypress)="validateService.numberOnly($event)" (input)="ValidateAadhaar(itemToEdit.AadharNo)"
                  placeholder="Aadhar No" maxlength="12">
              </div>
              <small *ngIf="!isValidAadhaar" class="text-danger fontsizeandfamilyCalibri">
                Invalid Aadhaar Number. please enter valid Aadhaar Number.
              </small>
            </div>
            <div class="col-lg-3">
              <div class="form-group text-left fontsizeandfamilyCalibri"> <!----- Passport No ------>
                <strong id="lblPassportNo">Passport No. </strong>
                <input type="text" name="PassportNo" id="PassportNo" class="form-control"
                  [(ngModel)]="itemToEdit.PassportNo" placeholder="Passport No" maxlength="20">
              </div>
            </div>
          </div>
          <div class="row grid-b">
            <div class="col-lg-3"> <!----- Pincode ------>
              <div class="form-group text-left fontsizeandfamilyCalibri">
                <strong id="lblPincode">Pincode</strong>
                <input type="text" name="Pincode" id="Pincode" class="form-control" [(ngModel)]="itemToEdit.PinCode"
                  (keypress)="validateService.numberOnly($event)" maxlength="10">
              </div>
            </div>
          </div>
          <div class="d-flex">
            <button type="button" id="btnClose" class="btn btn-md bg-primary mr-3" (click)="(caa)">
              <i class="fa fa-times mr-1" aria-hidden="true"></i>
              Close</button> <!----- Pop Up Close ------>
            <button type="button" id="save" [disabled]="f.form.pristine" class="btn btn-md bg-primary"
              (click)="SaveDoner()">
              <i [ngClass]="isInProgress ? 'spinner-border spinner-border-sm mr-1' : 'fa fa-save mr-1'"></i>
              Save</button> <!----- Save Data ------>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<!---Payment History-->
<div class="container ttm-bgcolor-whiteecolor" *ngIf="isPaymentHistory">

  <app-payment-history [selectedOnlinePatientRegistrationID]="SelectedOnlinePatientRegistrationID"
    [CarmePaymentGateway_key]="CarmePaymentGateway_key"
    [CarmePaymentGateway_secret]="CarmePaymentGateway_secret"></app-payment-history>

</div>